import { openDB } from 'idb';

const DB_NAME = 'AbsenFotoDB';
const DB_VERSION = 2;

export const initDB = () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db, oldVersion) {
      // Store foto (sudah ada di version 1)
      if (!db.objectStoreNames.contains('fotos')) {
        db.createObjectStore('fotos', { keyPath: 'timestamp' });
      }
      // Store asset — baru di version 2
      if (!db.objectStoreNames.contains('assets')) {
        const assetStore = db.createObjectStore('assets', { keyPath: 'kode' });
        assetStore.createIndex('nama', 'nama', { unique: false });
        assetStore.createIndex('kategori', 'kategori', { unique: false });
        assetStore.createIndex('lokasi', 'lokasi', { unique: false });
      }
      // Store pengajuan asset — baru di version 2
      if (!db.objectStoreNames.contains('asset_pengajuan')) {
        const pStore = db.createObjectStore('asset_pengajuan', { keyPath: 'id', autoIncrement: true });
        pStore.createIndex('jenis', 'jenis', { unique: false });
        pStore.createIndex('status', 'status', { unique: false });
        pStore.createIndex('created_at', 'created_at', { unique: false });
      }
    },
  });
};